import { useGetDailyFormVehicleTypesQuery } from "generated/graphql";
import { useMemo } from "react";

export default function useGetDailyFormVehicleTypes() {
  const { data: graphqlData, loading, error } = useGetDailyFormVehicleTypesQuery();

  const data = useMemo(() => {
    return graphqlData?.getDailyFormVehicleTypes || null;
  }, [graphqlData]);

  return { data, loading, error } as const;
}
